<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Contract - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">			
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTdg()">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTdg()">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-row>
							<b-col md="8">
             <b-form-group :label-cols="4" id="L1" label="Contract Name" label-for="Tdg1" horizontal>
              <b-form-input v-if="!edit" id="Tdg1" type="text" v-model="model.contract_name" class="plaintext-input" plaintext ></b-form-input>
              <b-form-input v-else id="Tdg1" type="text" v-model="model.contract_name"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L2" horizontal label="Type Contract" label-for="Tdg2">
                <b-form-input v-if="!edit" id="Tdg2" type="text" v-model="model.type_contract_name"  class="plaintext-input" plaintext></b-form-input>
                <b-form-select v-else :disabled="type_contract.length==0" value-field="id" text-field="name" id="Tdg2" v-model="model.type_contract_id" :options="type_contract" >
                    <template slot="first"><option :value="null" disabled>-- select type contract --</option></template>
                </b-form-select>
            </b-form-group> 
            <b-form-group :label-cols="4" id="L3" label="Start Date" label-for="Tdg3" horizontal>
                <b-form-input v-if="!edit" id="Tdg3" type="text" v-model="model.start_date" class="plaintext-input" plaintext ></b-form-input>
              <b-form-input v-else id="Tdg3" type="date" v-model="model.start_date"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L4" label="Of Months" label-for="Tdg4" horizontal>
               <b-form-input v-if="!edit" id="Tdg4" type="text" v-model="model.of_months"  class="plaintext-input" plaintext></b-form-input> 
              <b-form-input v-else id="Tdg4" type="text" v-model="model.of_months" v-mask="'##'" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L5" label="Volume" label-for="Tdg5" horizontal>
                <b-form-input v-if="!edit" id="Tdg5" type="text" v-model="model.volume"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg5" type="text" v-model="model.volume" v-mask="'#########'" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L6" label="Diff" label-for="Tdg6" horizontal>
                <b-form-input v-if="!edit" id="Tdg6" type="text" v-model="model.diff"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg6" type="text" v-model="model.diff" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'diff')" @blur.native="inputBlur('diff')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L7" horizontal label="Index Contract" label-for="Tdg7">
                <b-form-input v-if="!edit" id="Tdg7" type="text" v-model="model.index_contract_name"  class="plaintext-input" plaintext></b-form-input>
                <b-form-select v-else :disabled="index_contract.length==0" value-field="id" text-field="name" id="Tdg7" v-model="model.index_contract_id" :options="index_contract">
                 <template slot="first"><option :value="null" disabled>-- select index contract --</option></template>
                </b-form-select> 
            </b-form-group> 
            <b-form-group :label-cols="4" id="L8" label="App" label-for="Tdg8" horizontal>
                <b-form-input v-if="!edit" id="Tdg8" type="text" v-model="model.app"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg8" type="text" v-model="model.app" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'app')" @blur.native="inputBlur('app')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L9" label="trader" label-for="Tdg9" horizontal>
                <b-form-input v-if="!edit" id="Tdg9" type="text" v-model="model.trader"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg9" type="text" v-model="model.trader"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L10" label="Priority" label-for="Tdg10" horizontal>
                <b-form-input v-if="!edit" id="Tdg10" type="text" v-model="model.priority"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg10" type="text" v-model="model.priority" v-mask="'##'" autocomplete="off"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L11" label="Placeholder 1" label-for="Tdg11" horizontal>
                <b-form-input v-if="!edit" id="Tdg11" type="text" v-model="model.placeholder_1"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg11" type="text" v-model="model.placeholder_1" ></b-form-input>
            </b-form-group>  
            <b-form-group :label-cols="4" id="L12" label="Placeholder 2" label-for="Tdg12" horizontal>
                <b-form-input v-if="!edit" id="Tdg12" type="text" v-model="model.placeholder_2"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg12" type="text" v-model="model.placeholder_2" ></b-form-input>
            </b-form-group> 
            <b-form-group :label-cols="4" id="L13" label="Customer" label-for="Tdg13" horizontal>
                <b-form-input v-if="!edit" id="Tdg13" type="text" v-model="model.invoice_customer_name"  class="plaintext-input" plaintext></b-form-input>
                <b-form-select v-else :disabled="invoice_customer.length==0" value-field="id" text-field="name" id="Tdg13" v-model="model.invoice_customer_id" :options="invoice_customer">
                                <template slot="first"><option :value="null" disabled>-- select invoice customer --</option></template>
                </b-form-select> 
            </b-form-group>

            <b-form-group :label-cols="4" id="L15" label="Nomination(m3)" label-for="Tdg15" horizontal>
                <b-form-input v-if="!edit" id="Tdg15" type="text" v-model="model.nomination_m3"  class="plaintext-input" plaintext></b-form-input>
                <b-form-input v-else id="Tdg15" type="text" v-model="model.nomination_m3" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'nomination_m3')" @blur.native="inputBlur('nomination_m3')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L16" label="Nomination(bbl)" label-for="Tdg16" horizontal>
                <b-form-input v-if="!edit" id="Tdg16" type="text" v-model="model.nomination_bbl"  class="plaintext-input" plaintext></b-form-input>
                <b-form-input v-else id="Tdg16" type="text" v-model="model.nomination_bbl" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'nomination_bbl')" @blur.native="inputBlur('nomination_bbl')"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" id="L17" label="Post Appomt. Nomination" label-for="Tdg17" horizontal>
                <b-form-input v-if="!edit" id="Tdg17" type="text" v-model="model.post_appomt_nom"  class="plaintext-input" plaintext></b-form-input>
                <b-form-input v-else id="Tdg17" type="text" v-model="model.post_appomt_nom" autocomplete="off"  @keydown.native="myOnlyNumber($event, 'post_appomt_nom')" @blur.native="inputBlur('post_appomt_nom')"></b-form-input>
            </b-form-group>

            <b-form-group :label-cols="4" id="L18" label="Price Description" label-for="Tdg18" horizontal>
                <b-form-input v-if="!edit" id="Tdg18" type="text" v-model="model.price_description"  class="plaintext-input" plaintext></b-form-input>
              <b-form-input v-else id="Tdg18" type="text" v-model="model.price_description"></b-form-input>
            </b-form-group>

            <b-form-group v-if="!edit" :label-cols="4" id="L14" label="Attach Pdfs" label-for="file" horizontal>
              <div v-for="(pdf, index) in model.pdfs">
                  <p>{{pdf.name}}</p>   
              </div>
			      </b-form-group>
								<b-form-group v-else :label-cols="4" id="L144" label="Attach Pdfs" label-for="file" horizontal>
									<b-table striped show-empty empty-text="No pdf have been added"
										:fields = "[{key: 'delete', label: ' '}, {key: 'name', label: ' '}]" 
										:items="model.pdfs" stacked="sm" outlined small>
										<template slot="delete" slot-scope="item">
											<b-btn v-b-tooltip.hover title="Delete" v-on:click="removefile(item.index)" size="sm" class="pull-right"><i class="icon-close"></i></b-btn>
										</template>
										<template slot="name" slot-scope="item">
											<span v-if="item.item.name==''" class="show-details-cell">
												<input type="file" class="form-control-file" id="files" ref="file" accept="application/pdf" v-on:change="handleFileUpload(item.index)" />
              								</span>
											<span v-else>
												{{item.item.name}}
											</span>
										</template>
									</b-table>
									<b-row>
									<b-col sm="12">
										<b-btn  v-on:click="anotherfile()" size="sm" variant="primary" class="pull-right">Add pdf</b-btn>
									</b-col>
									</b-row>				      
			      				</b-form-group>

								<div slot="footer" v-show="edit">
									<b-button @click="update()" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
									<b-button @click="editTdg()" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-col>
						</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import invoice_service from './invoices_service'
	export default {
		name: 'InvoiceContract',
		created: function() {
			this.getCompanyData()
		},
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
                model       : {
                        contract_name       : '',
                        type_contract_id    : null,
                        type_contract_name    : '',
                        start_date          : '',
                        of_months           : '',
                        volume              : '',
                        diff                : '',
                        index_contract_id   : null,
                        index_contract_name   : '',
                        app                 : '',
                        trader              : '',
                        priority            : '',
                        placeholder_1       : '',
                        placeholder_2       : '',
                        invoice_customer_id : null,
                        invoice_customer_name : '',
                        pdfs                 : [],
                        nomination_m3       : '',
                        nomination_bbl      : '',
                        post_appomt_nom     : '',
                        price_description   : '',
                    },
				updateData      : null,
				originalData    : null,
				loadingData     : true,
        type_contract		: [],
        index_contract      : [],
        invoice_customer    : [],
        url                 : '',
        file                  : '',
        infile : {
            'name': '',
            'file_64':'',
        },
        otherfile : {
            'name': '',
            'file_64':'',
        }
 
			}
		},
		methods: {
			editTdg() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			getCompanyData() {
				invoice_service.getBy_icontract(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData       = data.invoice_contract
                            this.type_contract      = data.type_contract
                            this.index_contract     = data.index_contract
                            this.invoice_customer   = data.invoice_customer
                            console.log('--->',this.originalData)
                            //this.fluidtypeselect  = data.fluid_types					
							this.companyId      = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()							
							this.subTitle       = this.companyId
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return

                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
                if (this.model.contract_name === undefined || this.model.contract_name.trim().length == 0) {
                    this.$swal('Alert!', 'Contract Name can not be empty', 'warning')
                    return false
                }
                if (this.model.start_date === undefined || this.model.start_date.trim().length == 0) {
                    this.$swal('Alert!', 'Start Date can not be empty', 'warning')
                    return false
                }
                if (this.model.of_months === undefined || this.model.of_months== '') {
                    this.$swal('Alert!', 'Of Months can not be empty', 'warning')
                    return false
                }
                if (this.model.volume === undefined || this.model.volume == '') {
                    this.$swal('Alert!', 'Volume can not be empty', 'warning')
                    return false
                }
                if (this.model.diff === undefined || this.model.diff == '') {
                    this.$swal('Alert!', 'Diff can not be empty', 'warning')
                    return false
                }
                if (this.model.trader === undefined || this.model.trader.trim().length == 0) {
                    this.$swal('Alert!', 'Trader can not be empty', 'warning')
                    return false
                }
                if (this.model.priority === undefined || this.model.priority == '') {
                    this.$swal('Alert!', 'Priority can not be empty', 'warning')
                    return false
                }
                if (this.model.type_contract_id === undefined || this.model.type_contract_id == null) {
                    this.$swal('Alert!', 'Select Type Contract', 'warning')
                    return false
                }
                if (this.model.index_contract_id === undefined || this.model.index_contract_id == null) {
                    this.$swal('Alert!', 'Select Index Contract', 'warning')
                    return false
                }
                if (this.model.invoice_customer_id === undefined || this.model.invoice_customer_id == null) {
                    this.$swal('Alert!', 'Select Customer', 'warning')
                    return false
                }
				return true

			},
      update () {
        if (!this.okToUpdate()) {
					return
				}
        console.log('upd',this.model)
				invoice_service.update_icontract(this.companyId, this.model)
					.then((data) => {
						this.$swal(data.status, data.message, data.status)
							.then((result) => {
								this.getCompanyData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTdg() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Customer: " + this.model.contract_name+ " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						invoice_service.delete_icontract(this.companyId)
							.then(data => {
								this.$swal(data.status, data.message, data.status)
								if (data.status == 'success') {
									this.$router.replace('/invoice_contracts')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
      inputBlur(variableName) {
          let variableValue = this.model[variableName]
          if (variableValue.length == 0) {
            if (variableName!=="exchange_rate") {
                this.model[variableName] = "0.00"
            } else {
                this.model[variableName] = "0.0000"
            }
            
          } else {
            let tempValue = variableValue.split(".")
            if (tempValue.length == 1) {
                if (variableName!=="exchange_rate") {
                    this.model[variableName] = String(variableValue) + ".00"
                } else {
                    this.model[variableName] = String(variableValue) + ".0000"
                }           
            } else if (tempValue.length == 2) {
                if (variableName!=="exchange_rate") {
                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
                } else {
                    this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "0000").slice(0, 4)
                }
                
            }
          }
        },
      myOnlyNumber(evt, variableName) {
          let dotPosition = this.model[variableName].indexOf(".")
          let hasDot = dotPosition > -1
          let length = this.model[variableName].length
          if (variableName!=="exchange_rate") {
              this.isNumber(evt, hasDot, dotPosition, length, 2)
          } else {
              this.isNumber(evt, hasDot, dotPosition, length, 4)
          }
      },
      isNumber: function(evt, hasDot, dotPosition, length, n_digit) {

          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
            let selectionStart = evt.target.selectionStart;
            let selectionEnd = evt.target.selectionEnd;
            if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length -  n_digit> dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
              evt.preventDefault();
            } else {
              return true
            }
          } else {
            evt.preventDefault();
          }
      },
			handleFileUpload(index) {
				if (this.$refs.file.files.length>0) {

					this.file = this.$refs.file.files[0]
					this.infile.name = this.file.name//this.$refs.files.files[i].name
					
					let url = window.URL.createObjectURL(this.file)
					this.url = url
					setTimeout(() => window.URL.revokeObjectURL(url), 100)
					let reader = new FileReader()
					reader.readAsDataURL(this.file)             
					reader.onload = function() {
						localStorage.setItem('file_64', reader.result)      
						return
					}        
					this.infile.file_64 = localStorage.getItem('file_64')

					this.model.pdfs[index].name = this.infile.name
					this.model.pdfs[index].file_64 = this.infile.file_64
					console.log('-model-->',this.model.pdfs)  
				}
        	},
      removefile(otherfile) {
				  this.model.pdfs.splice(otherfile,1)
			},
			anotherfile() {

				if (this.model.pdfs.length===0) {
					this.model.pdfs.push(this.otherfile)
					this.infile = {
						'name': '',
						'file_64':'',
					}
				} else {
					let file_in 		= this.model.pdfs
					let file_in_index 	= file_in.map(o => o.name).indexOf('')
					if (file_in_index > -1) {
						this.$swal('warning', 'File no selected', 'warning')

					} else {
						this.otherfile = {
							'name': '',
							'file_64':'',
						}
						this.model.pdfs.push(this.otherfile)
						this.infile = {
							'name': '',
							'file_64':'',
						}						
					}

				}

			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/invoices/invoice_contract.vue